export default __webpack_public_path__ + "static/media/08_meow_m.6d37aa22.webp";